import { UnlockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Form, Input, message, Modal, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { adminLogin, forgetPassword, login } from '../../apis/auth'
import { setAdmin } from '../../store/adminSlice'
import { setUser } from '../../store/userSlice'
import './Login.less'
import { CHECKAUTH } from '../../constants/ActionTypes'
import { ROUTES } from '../../constants/Routing'
import { useTranslation } from 'react-i18next'
import useLogo from '../../hook/useLogo'

const emailFormat = /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
function Login ({ adminMode }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { pathname } = location || ''
  const [form] = Form.useForm()
  const { t: ln_t } = useTranslation()
  const [loginLoading, setLoginLoading] = useState(false)
  const logo = useLogo({ blackMode: true })

  const handleLogin = async fieldsValue => {
    setLoginLoading(true)
    const { password, username } = fieldsValue
    const params = { password: window.btoa(password), [adminMode ? 'adminName' : 'username']: username }

    const result = adminMode ? await adminLogin(params) : await login(params)
    if (result?.status === 200) {
      const { token } = result.data
      const updateState = adminMode ? setAdmin : setUser
      dispatch(updateState({ ...result.data, active: true, token }))
      const firstPage = adminMode ? '/' : result?.data?.nowGroupFunctionsDetail[0]?.link
      navigate(adminMode ? '/admin' : firstPage)
    }
    setLoginLoading(false)
  }

  const forgetPass = async () => {
    const email = form.getFieldValue('username')
    if (!email) return message.info(ln_t('login.PleaseEnterYourEmail'))
    if (!email.match(emailFormat)) return message.info(ln_t('login.PleaseEnterTheCorrectFormat'))
    const mode = pathname === ROUTES.ADMIN_LOGIN ? 'admin' : 'member'
    const result = await forgetPassword(mode, { email })
    if (result?.status === 200) {
      Modal.info({
        centered: true,
        icon: false,
        content: ln_t('login.resetEmailSent'),
        okText: 'Confirm'
      })
    } else message.info(result?.data?.message || 'Server Error')
  }

  useEffect(() => {
    dispatch({ type: CHECKAUTH.REQUEST })
  }, [])

  return (
    <>
      <main className="project-login-container">
        {loginLoading
          ? <Spin spinning />
          : <section className="project-login-inner">
              <div className="project-logo-box"><span>{logo}</span></div>
              <Spin spinning={loginLoading}>
                <Form initialValues={{ remember: true }} form={form} size="large" onFinish={handleLogin} requiredMark={false}>
                  <Form.Item
                    name="username"
                    rules={[{ required: true, message: ln_t('login.PleaseEnterYourEmail') }, { type: 'email', message: ln_t('login.PleaseEnterTheCorrectFormat') }]}
                  >
                    <Input prefix={<UserOutlined />} placeholder="Email" autoComplete="off" />
                  </Form.Item>
                  <Form.Item name="password" rules={[{ required: true, message: ln_t('login.PleaseEnterYourPassword') }]}>
                    <Input.Password prefix={<UnlockOutlined />} placeholder="Password" autoComplete="off" />
                  </Form.Item>
                  <span className='cursor-pointer' onClick={() => forgetPass()}>{ln_t('login.forgetPass')}</span>
                    <div className="login-btn-container"><Button type="primary" htmlType="submit">{ln_t('login.signIn')}</Button></div>
                </Form>
              </Spin>
            </section>}
      </main>
    </>
  )
}
export default Login
